class ContentTabs extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('.content-tabs__button');
    this.panels = this.querySelectorAll('.content-tabs__panel');
    this.panelsContainer = this.querySelector('.content-tabs__panels');
    this.buttonsWrapper = this.querySelector('.content-tabs__buttons-wrapper');
    this.activeButton = this.querySelector('.content-tabs__button--active');
    this.activePanel = this.querySelector('.content-tabs__panel--active');

    this.setHeight();
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    window.addEventListener('resize', this.setHeight.bind(this));
  }

  onButtonClick(event) {
    const button = event.currentTarget;
    if (button === this.activeButton) return;
    const buttonList = Array.from(this.buttons);
    const isForward = buttonList.indexOf(button) > buttonList.indexOf(this.activeButton);

    this.activeButton.classList.remove('content-tabs__button--active');
    this.activeButton.setAttribute('aria-selected', 'false');
    button.classList.add('content-tabs__button--active');
    button.setAttribute('aria-selected', 'true');
    this.activeButton = button;

    this.activePanel.classList.remove('content-tabs__panel--active');
    const nextPanel = this.panels[buttonList.indexOf(button)];
    nextPanel.classList.add('content-tabs__panel--active');
    this.activePanel = nextPanel;
    this.setHeight();

    this.scrollButtonToEdge(button, isForward);
  }

  scrollButtonToEdge(button, isForward) {
    if (!this.buttonsWrapper) return;
    const wrapperRect = this.buttonsWrapper.getBoundingClientRect();
    const buttonRect = button.getBoundingClientRect();
    const gutter = parseFloat(getComputedStyle(this.buttonsWrapper).scrollPaddingInlineStart) || 0;
    const delta = isForward
      ? buttonRect.left - wrapperRect.left - gutter
      : buttonRect.right - wrapperRect.right + gutter;
    const maxScrollLeft = this.buttonsWrapper.scrollWidth - this.buttonsWrapper.clientWidth;
    const targetScrollLeft = Math.max(0, Math.min(this.buttonsWrapper.scrollLeft + delta, maxScrollLeft));
    this.buttonsWrapper.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
  }

  setHeight() {
    if (!this.activePanel) return;
    this.panelsContainer.style.height = `${this.activePanel.scrollHeight}px`;
  }
}

customElements.define('content-tabs', ContentTabs);
